import React from 'react';
import classNames from 'classnames';
import { HeadingText } from '@paypalcorp/pp-react';

export default class extends React.Component {
  render() {
    let content = this.props.content;
    content = content.replace(/\n|\r\n|\r/, '<br/>');

    const paraStyling = classNames('paraLinkStyling', this.props.className);

    return (
      <div>
        <HeadingText
          as='p'
          size='sm'
          className={paraStyling}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    );
  }
}
